import React from 'react';

const ClientImageViewer = ({
    isOpen,
    onClose,
    images,
    currentIndex,
    nextImage,
    prevImage
}) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black/95 z-[60] flex items-center justify-center p-4">
            <button
                onClick={onClose}
                className="absolute top-4 right-4 text-white hover:text-gold z-50"
            >
                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>

            <div className="relative w-full max-w-5xl h-full flex items-center justify-center">
                {images.length > 1 && (
                    <button
                        onClick={prevImage}
                        className="absolute left-2 sm:left-4 text-white hover:text-gold z-50 bg-bg-soft rounded-full p-2"
                    >
                        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
                        </svg>
                    </button>
                )}

                <img
                    src={`${import.meta.env.VITE_API_URL || ''}/static/${images[currentIndex]}`}
                    alt={`Property Image ${currentIndex + 1}`}
                    className="max-w-full max-h-[90vh] object-contain"
                />

                {images.length > 1 && (
                    <button
                        onClick={nextImage}
                        className="absolute right-2 sm:right-4 text-white hover:text-gold z-50 bg-bg-soft rounded-full p-2"
                    >
                        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                        </svg>
                    </button>
                )}

                <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 text-white bg-bg-soft px-4 py-2 rounded-full">
                    {currentIndex + 1} / {images.length}
                </div>
            </div>
        </div>
    );
};

export default ClientImageViewer;
